// Reference translation keys, text and product feature order.
export default {
  nav: {
    brandProducts: 'Positive products', discover: 'Discover', allProducts: 'All products',
    otherProducts: 'Other products: {count}',
    connectedApps: 'Connected apps', currentProduct: "You're in {product}",
    openApp: 'Open {product} in a new tab', discoverProduct: 'Discover {product}',
  },
  actions: {
    tryFree: 'Try for free', discover: 'Discover', discoverProduct: 'Discover {product}',
    backToCatalog: 'Back to all products',
    signIn: 'Sign in', close: 'Close',
  },
  agent: {
    useAssistant: 'Use in your AI assistant', title: 'Use {product} in your AI assistant',
    description: 'Connect your assistant to {product} using its MCP server.',
    other: 'Other',
    copyPrompt: 'Copy prompt',
    copyDone: 'Copied', copyRetry: 'Retry',
    connectTitle: 'Choose your assistant', connect: 'Connect', availableFor: 'Available for {product}',
    connectionHint: 'You may need to sign in and approve access.',
    permissions: 'Your assistant can only access the data and actions you authorize.',
    copy: 'Copy the agent setup prompt for {product}',
    copied: 'Prompt copied. Paste it in your agent.', copyError: 'Could not copy the prompt. Please try again.',
  },
  catalog: {
    title: 'Discover Positive products', description: 'Tools that work alongside {product}.',
    descriptionDefault: 'Tools for your marketing and sales teams.', empty: 'No products to discover.',
  },
  product: { featuresTitle: 'What you can do with {product}' },
  status: { current: 'Current app', connected: 'Connected app' },
  accessibility: { openMenu: 'Open product navigation', newTab: 'Opens in a new tab' },
  categories: { emailSignatures: 'Email signatures', emailing: 'Emailing', seo: 'SEO & GEO', socialMedia: 'Social media', sales: 'Sales' },
  products: {
    signitic: {
      tagline: 'Email signature management',
      description: 'Centralise every email signature and turn them into a marketing channel.',
      features: ['Same signature for the whole company', 'Banner campaigns in every email', 'Clicks and reach analytics'],
    },
    user: {
      tagline: 'Emailing & customer engagement',
      description: 'Automation, CRM and live chat to engage your contacts at the right moment.',
      features: ['Automated email & SMS journeys', 'CRM with contacts and deals', 'Live chat on your website'],
    },
    surfer: {
      tagline: 'SEO & GEO content optimisation',
      description: 'Write content that ranks on Google and gets cited by AI assistants.',
      features: ['Content briefs that rank on Google', 'Get cited in ChatGPT & AI answers', 'AI article writer'],
    },
    iconosquare: {
      tagline: 'Social media management & analytics',
      description: 'Schedule, reply and measure every social network from one platform.',
      features: ['Schedule posts on every network', 'One inbox for comments & DMs', 'Analytics and reports'],
    },
    humanlinker: {
      tagline: 'AI sales copilot',
      description: 'Engage each prospect in a unique way and turn conversations into revenue.',
      features: ['AI lead recommendations', 'Personalised outreach sequences', 'Meeting prep in one click'],
    },
    ubic: {
      tagline: 'Parallel dialer for sales teams',
      description: 'A parallel dialer that lets sales teams reach more prospects in less time.',
      features: ['Call several prospects at once', 'Only connected calls reach you', 'Syncs with your CRM'],
    },
    nocrm: {
      tagline: 'Lead management for salespeople',
      description: 'Track every lead from first contact to closed deal, without CRM overhead.',
      features: ['Every lead in one pipeline', 'Reminders so no deal slips', 'Mobile app for the field'],
    },
  },
};
